<p class="w-full h-full text-gray-500 text-lg text-center flex justify-center items-center gap-1 bg-white">
    Powered by <img class="h-6 w-auto" src="/assets/quartoloom-logo.png" />
</p>
